module.exports = __webpack_public_path__ + "static/vue-theme-material-kit-3af6f0e6881992a9172b3a422b0e9e66.jpg";